import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'account',
    templateUrl: 'account.component.html',
    styleUrls: ['account.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AccountComponent implements OnInit {
    model: any = {};
    loading = false;
    error = '';

    constructor() {
    }

    ngOnInit() {

    }

    login() {

    }
}
